/** 폼 문항 1건 → 서버 SourceQuestion. 채팅 턴이 매번 쓰는 직렬화를 재사용해 계약 드리프트를 막는다. */
import { type BuildQuizListItem } from '../../../form/schema/BuildQuizListSchema';
import { serializeCurrentQuizListToAiBuilderQuestions } from '../../ai-builder-chat/utils/aiBuilderQuestionSnapshot';

import { type SourceQuestionDto } from './questionCardAiEndpoints';

/** 이미지 전용 선지는 텍스트가 비어 서버가 빈 슬롯으로 오인한다 — 자리표시 텍스트로 "채워짐"을 알린다. */
export const IMAGE_ONLY_OPTION_PLACEHOLDER = '(image option)';

export const toSourceQuestion = (
  quiz: BuildQuizListItem,
): SourceQuestionDto => {
  const [snapshot] = serializeCurrentQuizListToAiBuilderQuestions([quiz]);
  if (snapshot == null)
    throw new Error('Failed to serialize quiz for AI action');

  const data = { ...snapshot.data } as SourceQuestionDto;

  // curriculum_list 는 스냅샷이 이미 "성취기준 부여 이후 편집됨" 을 걸러 실어 준다.
  // 여기서 quiz.curriculumList 로 덮어쓰면 그 판정이 세탁되므로 손대지 않는다.
  if (quiz.type === 'multiple') {
    data.options = quiz.multipleData.choiceList.map((choice, index) => {
      const text = (data.options ?? [])[index] ?? '';
      return !text.trim() && choice.imageUrl
        ? IMAGE_ONLY_OPTION_PLACEHOLDER
        : text;
    });
  }

  return {
    ...data,
    quiz_type: snapshot.quiz_type,
    question: String(data.question ?? ''),
  };
};
